;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.dashboard')
    .controller('DashboardController', DashboardController)

  DashboardController.$inject = [
    // Angular
    '$q', '$state',
    // Libs
    // Managers
    'CardManager',
    // Services
    'CardCreationService', 'DisplayService',
    // Const
    // Resolved
    'currentDashboard'
  ]

  function DashboardController (// Angular
    $q, $state,
    // Libs
    // Managers
    CardManager,
    // Services
    CardCreationService, DisplayService,
    // Const
    // Resolved
    currentDashboard) {
    var self = this
    var colNumbers = 8
    var backupCards = _.cloneDeep(currentDashboard.cards)

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        cards: currentDashboard.cards,
        // Public Methods
        createCard: createCard,
        duplicateCard: duplicateCard,
        removeCard: removeCard
      })

      init()
    }

    function init () {
      self.gridsterOpts = {
        swapping: false,
        pushing: false,
        floating: false,

        width: colNumbers * 240,

        mobileModeEnabled: false,
        defaultSizeX: 1,
        minRows: 1,
        maxSizeX: 16,
        maxSizeY: 12,
        minColumns: colNumbers,
        columns: colNumbers,
        colWidth: 230,
        rowHeight: 230,
        draggable: {
          enabled: true,
          handle: '.dashboard-card-anchor',
          stop: function () {
            var changedCards = _.filter(currentDashboard.cards, function (c) {
              var cloned = _.find(backupCards, { _id: c._id })
              if (cloned) {
                return (cloned.col !== c.col || cloned.row !== c.row)
              }
            })
            $q.all(_.map(changedCards, function (c) { return c.save() })).then(function () {
              backupCards = _.cloneDeep(currentDashboard.cards)
            })
          }
        },
        resizable: {
          enabled: true,
          handles: ['se'],
          stop: function () {
            var changedCards = _.filter(currentDashboard.cards, function (c) {
              var cloned = _.find(backupCards, { _id: c._id })
              if (cloned) {
                return (cloned.sizeX !== c.sizeX || cloned.sizeY !== c.sizeY)
              }
            })
            $q.all(_.map(changedCards, function (c) { return c.save() })).then(function () {
              backupCards = _.cloneDeep(currentDashboard.cards)
            })
          }
        }
      }
    }

    function removeCard (card) {
      DisplayService.confirmDeletion().then(function () {
        card.delete().then(function () {
          _.remove(currentDashboard.cards, { _id: card._id })
          currentDashboard.save('all').then(function () {
            $state.reload()
          })
        })
      })
    }

    function duplicateCard (card) {
      var newCard = CardManager.create(card).clone()
      newCard.save().then(function (saved) {
        currentDashboard.cards.push(saved.data)
        currentDashboard.save().then(function () {
          $state.reload()
        })
      })
    }

    function createCard () {
      CardCreationService.configureCard().then(function (card) {
        var isNew = !card._id
        card.save().then(function () {
          if (isNew) {
            currentDashboard.cards.push(card)
            currentDashboard.save().then(function () {
              $state.reload()
            })
          }
        })
      })
    }
  }
})(window.angular, window._)
